<template>
  <div class="simulator">
    <div class="simulator__display">
      <canvas id="monitor" width="800" height="600"></canvas>
    </div>
    <div class="simulator__controls">
      <dl class="controls">
        <div class="controls__item">
          <dt>周波数</dt>
          <dd>
            <div class="controls__range">
              <input
                v-model="freq"
                type="range"
                :min="minFreq"
                :max="maxFreq"
              />
              <div class="controls__scale">
                <span class="controls__min">{{ minFreq }}</span>
                <span class="controls__max">{{ maxFreq }}</span>
              </div>
            </div>
            <span class="controls__num">
              <input
                @input="debounceInput"
                data-key="freq"
                type="number"
                :min="minFreq"
                :max="maxFreq"
                :value="freq"
              />
              <span class="controls__unit">Hz</span>
            </span>
          </dd>
        </div>
        <div class="controls__item">
          <dt>振幅</dt>
          <dd>
            <div class="controls__range">
              <input v-model="amp" type="range" min="0" :max="maxAmp" />
              <div class="controls__scale">
                <span class="controls__min">{{ 0 }}</span>
                <span class="controls__max">{{ maxAmp }}</span>
              </div>
            </div>
            <span class="controls__num">
              <input
                @input="debounceInput"
                data-key="amp"
                type="number"
                min="0"
                :max="maxAmp"
                :value="amp"
              />
            </span>
          </dd>
        </div>
        <div class="controls__item">
          <dt>距離</dt>
          <dd>
            <div class="controls__range">
              <input v-model="dist" type="range" min="0" :max="maxDist" :disabled="isBroken" />
              <div class="controls__scale">
                <span class="controls__min">{{ 0 }}</span>
                <span class="controls__max">{{ maxDist }}</span>
              </div>
            </div>
            <span class="controls__num">
              <input
                @input="debounceInput"
                data-key="dist"
                type="number"
                min="0"
                :max="maxDist"
                :value="dist"
                :disabled="isBroken"
              />
              <span class="controls__unit">cm</span>
            </span>
          </dd>
        </div>
        <div class="controls__item controls__item--switch">
          <dt>波形表示</dt>
          <dd>
            <label class="switch">
              <input v-model="showWave" type="checkbox">
              <span class="switch__container"></span>
            </label>
          </dd>
        </div>
      </dl>
      <div class="control-button">
        <button type="button" @click="controlSwitch">{{ buttonText }}</button>
      </div>
      <div class="simulator__status" v-if="isBroken">
        <p><strong>ワイングラスが割れました！</strong></p>
        <button type="button" @click="reset">Reset</button>
      </div>
    </div>
  </div>
</template>

<script>
import Simulator from "@/simulator.js";
import DEFAULT from "@/defaultValues.js";

const INI = window.INI;

export default {
  name: "Wine Glass Resonance Simulator",
  data() {
    return {
      simulator: null,
      freq: INI.freq,
      amp: INI.amp,
      dist: INI.dist,
      buttonText: "Start",
      minFreq: Math.max(0, INI.minFreq || DEFAULT.minFreq),
      maxFreq: INI.maxFreq || DEFAULT.maxFreq,
      maxAmp: INI.maxAmp || DEFAULT.maxAmp,
      maxDist: INI.maxDist || DEFAULT.maxDist,
      isBroken: false,
      debounce: null,
      showWave: INI.showWave || DEFAULT.showWave,
    };
  },
  methods: {
    controlSwitch() {
      if (this.simulator.isStarting) {
        this.simulator.stop();
        this.buttonText = "Start";
      } else {
        this.simulator.start();
        this.buttonText = "Stop";
      }
    },
    broken() {
      this.isBroken = true;
    },
    debounceInput(e) {
      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        const key = e.target.getAttribute("data-key");
        let val = e.target.value;

        if (e.target.hasAttribute("min")) {
          val = Math.max(val, e.target.getAttribute("min"));
        }
        if (e.target.hasAttribute("max")) {
          val = Math.min(val, e.target.getAttribute("max"));
        }

        e.target.value = val;
        this[key] = val;
      }, 200);
    },
    reset() {
      this.simulator.stop();
      this.buttonText = "Start";
      this.simulator.grassSet();
      this.isBroken = false;
    },
  },
  watch: {
    freq(newVal) {
      this.simulator.freq = newVal;
    },
    amp(newVal) {
      this.simulator.amp = newVal;
    },
    dist(newVal) {
      this.simulator.dist = newVal;
    },
    showWave(newVal) {
      this.simulator.showWave = newVal;
    }
  },
  mounted() {
    this.simulator = new Simulator("#monitor", INI);
    window.simulator = this.simulator;

    document.body.addEventListener("wineGrassBroken", this.broken);
  },
};
</script>
